import React, {PureComponent} from "react";
import {withTranslation} from "react-i18next";
import {fixedToWithoutRound, getTokenDecimals} from "../../helpers/Utils";
import {isEqual} from "lodash";

class OrderDetails extends PureComponent {
  constructor(props) {
    super(props);
    this.details = {};
    this.UpdateDetails(props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {form, values, orders, marketType} = nextProps;
    if (
      form !== this.props.form ||
      marketType !== this.props.marketType ||
      !isEqual(values, this.props.values) ||
      !isEqual(orders, this.props.orders)
    ) {
      this.UpdateDetails(nextProps);
    }
  }

  UpdateDetails = props => {
    const {form, values, orders, tradeFee, marketType} = props;
    if (values.amount && (values.type === 'MARKET' || values.price)) {
      const details = this.computeDetails(values, orders, tradeFee, marketType);
      if(!isEqual(details, this.details)) {
        form.change('details', details);
        this.details = details;
      }
    }
  };

  computeDetails = (values, orders, tradeFee, marketType) => {
    const {type, side, amount, price} = values;
    const result = this.computeTotalPrice(type, amount, price, orders);
    const fee = this.computeFee(
      type,
      side === 'BUY' ? amount : result.totalPrice,
      tradeFee,
      marketType
    );
    const receivedAmount = this.computeReceivedAmount(fee, side === 'BUY' ? amount : result.totalPrice);
    return {...result, fee, receivedAmount};
  };

  computeTotalPrice = (type, amount, price, orders) => {
    if (type !== 'MARKET') {
      return {totalPrice: Number(amount) * Number(price)};
    }
    return this.computeMarketTotalPrice(amount, orders);
  };

  computeMarketTotalPrice = (amount, orders) => {
    let remainedAmount = Number(amount);
    let totalPrice = 0;
    let i = 0;
    if (!orders || !orders.length) {
      return {
        amount: 0,
        totalPrice: 0,
        fixedPrice: 0,
      };
    }
    while (remainedAmount) {
      if (!orders[i]) {
        break;
      }
      const orderAmount = Number(orders[i].amount);
      if (orderAmount <= remainedAmount) {
        totalPrice += orderAmount * Number(orders[i].price);
        remainedAmount -= orderAmount;
      } else {
        totalPrice += remainedAmount * Number(orders[i].price);
        remainedAmount = 0;
      }
      i++;
    }
    return {
      computedAmount: Number(amount) - remainedAmount,
      totalPrice: !remainedAmount ? totalPrice : 0,
      fixedPrice: !remainedAmount ? totalPrice / Number(amount) : 0,
    };
  };

  computeFee = (type, value, tradeFee, marketType) => {
    const {fiat, crypto} = tradeFee;
    const maker = marketType === 'FIAT' ? fiat.maker_fee : crypto.maker_fee;
    const taker = marketType === 'FIAT' ? fiat.taker_fee : crypto.taker_fee;
    if (type === 'LIMIT') {
      return Number(value) * Number(maker);
    }
    return Number(value) * Number(taker);
  };

  computeReceivedAmount = (fee, value) => {
    return value - fee;
  };

  render() {
    const {t, pairName, values, locales, hasValidationErrors, priceDecimals} = this.props;
    const names = pairName.split('/');
    const baseToken = names[0];
    const quoteToken = names[1];
    return (
      <div className="mb-2" style={{fontSize: 14}}>
        {!!this.details.totalPrice && !!values.amount &&
          <div className="mb-1">
            <span className="text-muted">
              {t("Total Price")}
            </span>
            <span className="mx-2 font-weight-semibold">
              {`${fixedToWithoutRound(this.details.totalPrice, priceDecimals)} ${locales[1]}`}
            </span>
          </div>
        }
        {values.type !== 'STOP_LIMIT' && !!this.details.fixedPrice && !!values.amount &&
          <div className="mb-1">
            <span className="text-muted">
              {t('Fixed Price')}
            </span>
            <span className="mx-2 font-weight-semibold">
              {`${fixedToWithoutRound(this.details.fixedPrice, priceDecimals)} ${locales[1]}`}
            </span>
          </div>
        }
        {values.type !== 'STOP_LIMIT' && !!this.details.fee && !hasValidationErrors && !!values.amount &&
          <div className="mb-1">
            <span className="text-muted">
              {t('Fee')}
            </span>
            <span className="mx-2 font-weight-semibold">
              {`${fixedToWithoutRound(this.details.fee, getTokenDecimals(values.side === 'SELL' ? quoteToken : baseToken))} ${values.side === 'SELL' ? locales[1] : locales[0]}`}
            </span>
          </div>
        }
        {values.type !== 'STOP_LIMIT' && !!this.details.receivedAmount && !hasValidationErrors && !!values.amount &&
          <div className="mb-1">
            <span className="text-muted">
              {t('Received Amount')}
            </span>
            <span className="mx-2 font-weight-semibold text-info">
              {`${fixedToWithoutRound(this.details.receivedAmount, getTokenDecimals(values.side === 'SELL' ? quoteToken : baseToken))} ${values.side === 'SELL' ? locales[1] : locales[0]}`}
            </span>
          </div>
        }
      </div>
    );
  }
}

export default withTranslation()(OrderDetails);
